(() => {
  const variantsEl = document.getElementById("haut-variants-json");
  if (!variantsEl) return;

  // Only run on ONE product
  // Replace this with your real product.id if needed
  const ONLY_PRODUCT_ID = "15817857827151";
  const pid = variantsEl.dataset.productId || "";
  if (pid !== ONLY_PRODUCT_ID) return;

  let variants = [];
  try {
    variants = JSON.parse(variantsEl.textContent || "[]");
  } catch (e) {
    console.warn("[HAUT] variants JSON parse failed", e);
    return;
  }

  const extractBars = (s) => {
    const m = String(s || "").match(/\d+/);
    return m ? Number(m[0]) : 0;
  };

  const eur = (cents) =>
    ((Number(cents) || 0) / 100).toLocaleString("fr-FR", {
      style: "currency",
      currency: "EUR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

  const getPerBarLabel = (bars) => {
    const v = variants.find((x) => extractBars(x.option1 || x.title) === bars);
    if (!v || !bars) return null;

    const centsPerBar = v.price / bars;
    return `${eur(centsPerBar)}`;
  };

  const ensureBadge = (el, text) => {
    if (!el || !text) return;

    // Avoid duplicating
    let badge = el.querySelector(".haut-perbar-badge");
    if (!badge) {
      badge = document.createElement("span");
      badge.className = "haut-perbar-badge";
      el.appendChild(badge);
    }
    badge.textContent = text;
  };

  const decorate = () => {
    // Theme typically renders these as .variant-picker__option-values containing .option-value
    const optionEls = Array.from(
      document.querySelectorAll(".variant-picker__option-values .option-value")
    );

    // If the theme uses different wrappers, fallback to direct children
    const fallbackEls =
      optionEls.length > 0
        ? optionEls
        : Array.from(
            document.querySelectorAll(".variant-picker__option-values > *")
          );

    fallbackEls.forEach((el) => {
      const txt = (el.textContent || "").replace(/\s+/g, " ").trim();
      const bars = extractBars(txt);
      if (!bars) return;

      const label = getPerBarLabel(bars);
      if (!label) return;

      ensureBadge(el, label);
    });
  };

  // Run now
  decorate();

  // Re-run on variant rerenders (your theme uses product-rerender a lot)
  const root =
    document.querySelector("product-rerender") ||
    document.querySelector(".product") ||
    document.body;

  const obs = new MutationObserver(() => requestAnimationFrame(decorate));
  obs.observe(root, { childList: true, subtree: true });

  // Some themes also dispatch these events
  document.addEventListener("variant:change", decorate);
  document.addEventListener("product:variant-change", decorate);

  console.log("[HAUT] €/bar badges enabled");
})();
